import { isNil, isValid } from "@visactor/vutils";

export const getTooltipActualActiveType = spec => {
    var _a, _b, _c;
    if (!1 === (null == spec ? void 0 : spec.visible)) return [];
    const activeTypeMap = {
        mark: !1 !== (null === (_a = null == spec ? void 0 : spec.mark) || void 0 === _a ? void 0 : _a.visible),
        dimension: !1 !== (null === (_b = null == spec ? void 0 : spec.dimension) || void 0 === _b ? void 0 : _b.visible),
        group: !1 !== (null === (_c = null == spec ? void 0 : spec.group) || void 0 === _c ? void 0 : _c.visible)
    };
    return isValid(null == spec ? void 0 : spec.activeType) && Object.keys(activeTypeMap).forEach((t => {
        var _a;
        activeTypeMap[t] = null === (_a = null == spec ? void 0 : spec.activeType) || void 0 === _a ? void 0 : _a.includes(t);
    })), Object.keys(activeTypeMap).filter((t => activeTypeMap[t]));
};

export function isEmptyPos(params) {
    return isNil(params.mark) && isNil(params.model) && isNil(params.datum);
}
//# sourceMappingURL=common.js.map
